module.exports = __webpack_public_path__ + "img/default.0c17bfd3.png";